import React, { ComponentProps } from 'react';

import Trigger from '../layout/Trigger';

export const defaultRenderTrigger = (props: ComponentProps<typeof Trigger>) => (
  <Trigger {...props} />
);
